import React from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

interface ActionButtonsProps {
  onPrimaryClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onSecondaryClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  primaryText: string;
  secondaryText: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onPrimaryClick,
  onSecondaryClick,
  primaryText,
  secondaryText,
}) => {
  return (
    <div className="filterItem">
      <div>
        <ButtonToolbar aria-label="" className="filterBtns">
          <ButtonGroup className="me-2" aria-label="First group">
            <button
              className="btn btnPrimary"
              onClick={onPrimaryClick}
              style={{ minWidth: 110 }}
            >
              {primaryText}
            </button>
          </ButtonGroup>
          <ButtonGroup>
            <button className="btn btnSecondary" onClick={onSecondaryClick}>
              {secondaryText}
            </button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
    </div>
  );
};

export default ActionButtons;
